module.exports = __webpack_public_path__ + "static/media/template_import_mcu.bea4625d.xlsx";